import React, { useEffect } from 'react';
import { Container, Box, Typography, Button } from '@mui/material';

const redirectURL = process.env.REACT_APP_PORTAL_URL;

const SessionExpired = () => {

  // Clear local storage when the component mounts
  useEffect(() => {
    localStorage.clear();
  }, []);

  const handlePortalRedirect = () => {
    window.location.href = redirectURL;
  };

  return (
    <Container maxWidth="sm" sx={{ textAlign: 'center', mt: 8 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h3" color="error" gutterBottom>
          Session Expired
        </Typography>
        <Typography variant="h6" color="textSecondary">
          Your session has expired. Please log in again through the Bankers Agent Portal.
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
        <Button variant="contained" color="primary" onClick={handlePortalRedirect}>
          Bankers Agent Portal
        </Button>
      </Box>
    </Container>
  );
};

export default SessionExpired;
